<script lang="ts" setup>
import { ref, onMounted, reactive } from "vue";
import { mountedBase, onSave, BaseSetup, onDelete } from "@/DataLoaderStatic";
import AUApi from "@/api";
import { goBack } from "@/NavigationHelper";
let deleteVisible = ref<boolean>(false);
const emit = defineEmits(["back", "save"]);
const props = defineProps<{
  bewegungsdaten?: boolean;
  newData?: boolean;
  siteData?: any;
}>();
const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "Web_DVH_Anlage_Akquisition",
  bewegungsdaten: props.bewegungsdaten,
  emitBack: () => emit("back"),
};

const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  await mountedBase(uiData, pageParams);

  if (!uiData.showLoading && uiData.data && uiData.data.length > 0) {
    if (uiData.data && uiData.data[0].aic_Bew_pool) {
      deleteVisible.value = true;
    }
  }
  uiData.showLoading = false;
  uiData.initialized = true;
});
async function bewDelete() {
  if (uiData.data && uiData.data[0].aic_Bew_pool) {
    await onDelete(uiData, pageParams, uiData.data[0].aic_Bew_pool, "");
    emit("back");
  }
}
</script>
<template>
  <v-sheet class="noPaddingNoMargin">
    <v-progress-linear
      :indeterminate="true"
      v-if="uiData.showLoading"
      color="dvhSlider"
    ></v-progress-linear>
    <v-card v-if="uiData.initialized">
      <v-row class="pt-5 pa-2">
        <v-col cols="12" sm="6">
          <EditDatePicker kennung="VALIDITY"> </EditDatePicker>
          <EditComboBox kennung="KONTAKTART" :queryZeitbereich="uiData.zeitbereich" />
        </v-col>
        <v-col cols="12" sm="6">
          <EditComboBox
            kennung="TRANSMITTAL_MODE"
            :queryZeitbereich="uiData.zeitbereich"
          />
          <EditComboBox kennung="ANSPRECHPERSON" :queryZeitbereich="uiData.zeitbereich" />
        </v-col>
      </v-row>
      <EditFileChoicer kennung="ABLAGE" />
      <EditTextArea class="px-2" kennung="MEMO" />
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <CommonBaseButtons
          :deleteVisible="deleteVisible"
          :createVisible="false"
          :refreshVisible="false"
          :backVisible="false"
          @delete="bewDelete"
          @back="goBack()"
          :saveVisible="true"
        ></CommonBaseButtons>
      </v-card-actions>
    </v-card>
  </v-sheet>
</template>
